module.exports = __webpack_public_path__ + "check-out-icon.png?8cef454fdb1a0a98329723c91cffe9c0";